export default {
  title: 'Tavoli',
  count_one: '{{count}} tavolo',
  count_other: '{{count}} tavoli',
  filtered_count: '{{shown}} di {{count}} tavoli',
  intro:
    'Ogni tavolo ha il proprio link e codice QR. Gli ospiti che lo scansionano ordinano per quel tavolo e tu vedi il tavolo su ogni ordine.',
  migrated: {
    title: 'Il servizio in camera/al tavolo ora è Ordini al tavolo',
    description:
      'Abbiamo aggiunto un tavolo per ciascuna delle tue sedi, con lo stesso nome, così gli ospiti possono continuare a ordinare. Rinominali in base ai tuoi tavoli o aggiungine altri.',
  },
  add: {
    label: 'Aggiungi un tavolo',
    placeholder: 'es. 7, 1A o Terrazza 2',
    button: 'Aggiungi tavolo',
  },
  errors: {
    empty: 'Inserisci il nome del tavolo.',
    duplicate: 'Esiste già un tavolo chiamato «{{name}}».',
    too_long: 'Il nome di un tavolo può contenere fino a {{max}} caratteri.',
  },
  columns: {
    order: 'Ordine',
    table: 'Tavolo e link',
    on: 'Attivo',
    copy: 'Copia link',
    qr: 'Codice QR',
    actions: 'Azioni',
  },
  switch: {
    on: 'Attivo',
    off: 'Disattivo',
  },
  buttons: {
    copy: 'Copia link',
    copied: 'Copiato',
    download_qr: 'Scarica codice QR',
    qr_short: 'Codice QR',
    rename: 'Rinomina',
    delete: 'Elimina',
    save: 'Salva',
    cancel: 'Annulla',
  },
  aria: {
    move: 'Sposta {{name}} (tasti freccia)',
    switch: '{{name}} attivo',
    copy: 'Copia il link per {{name}}',
    copied: 'Link copiato',
    download_qr: 'Scarica il codice QR per {{name}}',
    rename: 'Rinomina {{name}}',
    delete: 'Elimina {{name}}',
    more: 'Altro per {{name}}',
    new_name: 'Nuovo nome per {{name}}',
  },
  tooltips: {
    move: 'Trascina per riordinare',
    move_disabled: 'Cancella la ricerca per riordinare',
  },
  rename_hint: 'Il link e il codice QR restano invariati.',
  no_link: 'Nessun indirizzo del negozio',
  search: {
    placeholder: 'Cerca tavoli',
    no_results: 'Nessun tavolo chiamato «{{text}}».',
  },
  load_failed: {
    title: 'Impossibile caricare i tavoli.',
    retry: 'Riprova',
  },
  empty: {
    title: 'Ancora nessun tavolo',
    text: 'Aggiungi i tuoi tavoli qui sopra per ottenere un link e un codice QR per ciascuno. Gli ospiti non possono ordinare al tavolo finché non ne aggiungi uno.',
  },
  delete: {
    title: 'Eliminare il tavolo «{{name}}»?',
    warning:
      'I codici QR stampati per questo tavolo smetteranno di funzionare. Gli ospiti che ne scansionano uno vengono invitati a rivolgersi al personale.',
    softer: "Per interrompere per un po' gli ordini a questo tavolo, disattivalo.",
    confirm: 'Elimina tavolo',
    cancel: 'Annulla',
  },
  announcements: {
    moved: '«{{name}}» spostato in posizione {{position}} di {{count}}.',
    instructions: 'Per spostare un tavolo, seleziona la sua maniglia e premi la freccia su o giù.',
  },
  qr_image: {
    table: 'Tavolo',
  },
  toasts: {
    added: 'Tavolo «{{name}}» aggiunto',
    renamed: '«{{old}}» rinominato in «{{name}}»',
    deleted: 'Tavolo «{{name}}» eliminato',
    switched_on: '«{{name}}» attivato',
    switched_off: '«{{name}}» disattivato',
    failed_to_save: 'Salvataggio non riuscito. Riprova.',
    failed_to_reorder: 'Il nuovo ordine non è stato salvato. Riprova.',
    failed_to_download_qr: 'Impossibile salvare il codice QR. Riprova.',
    copy_failed: 'Impossibile copiare il link. Riprova.',
  },
};
